import { render, staticRenderFns } from "./WaveSurferVoice.vue?vue&type=template&id=07d561cf&scoped=true&"
import script from "./WaveSurferVoice.vue?vue&type=script&lang=js&"
export * from "./WaveSurferVoice.vue?vue&type=script&lang=js&"
import style0 from "./WaveSurferVoice.vue?vue&type=style&index=0&id=07d561cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d561cf",
  null
  
)

export default component.exports